import React from 'react';

interface PlayIconProps {
  width?: number;
  height?: number;
  fill?: string;
}

const PlayIcon: React.FC<PlayIconProps> = ({
  width = 24,
  height = 24,
  fill = '#BCD0BF',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 24C5.37983 24 0 18.6127 0 11.9925C0 5.37235 5.37983 0 12 0C18.6202 0 24 5.3873 24 11.9925C24 14.3985 23.2976 16.7223 21.9452 18.7098C21.5469 19.3003 21.098 19.8515 20.6038 20.359C20.041 20.9368 19.4195 21.4578 18.7472 21.9153C16.7522 23.2752 14.4209 24 12 24Z"
        fill={fill}
      />
      <path
        d="M17.0723 11.181C17.6402 11.5792 17.6402 12.4205 17.0723 12.8187L9.73428 17.9631C9.07157 18.4277 8.16023 17.9536 8.16023 17.1443L8.16023 6.85541C8.16023 6.04606 9.07157 5.57199 9.73428 6.03659L17.0723 11.181Z"
        fill="white"
      />
      <path
        d="M14.3997 15.6009L10.205 18.4751C9.54133 18.9298 8.63973 18.4547 8.63973 17.6502L8.63973 7.3364C8.63973 6.52705 9.55106 6.05297 10.2138 6.51758L17.5518 11.662C18.1197 12.0602 18.1197 12.9015 17.5518 13.2997L16.2069 14.2425"
        stroke="#1A1A1A"
        strokeLinecap="round"
      />
      {[...Array(3)].map((_, i) => (
        <path
          key={i}
          d="M14.3997 15.6009L10.205 18.4751C9.54133 18.9298 8.63973 18.4547 8.63973 17.6502L8.63973 7.3364C8.63973 6.52705 9.55106 6.05297 10.2138 6.51758L17.5518 11.662C18.1197 12.0602 18.1197 12.9015 17.5518 13.2997L16.2069 14.2425"
          stroke="black"
          strokeOpacity="0.2"
          strokeLinecap="round"
        />
      ))}
    </svg>
  );
};

export default PlayIcon;
